module.exports = __webpack_public_path__ + "img/brain.af82fbb9.svg";